export default "https://cdn-web.disco.co/image_generator-01da718268e94e12cce5cb0bec0909f2.png";